

export class VehicleDetailsGroupOutput implements IVehicleDetailsGroupOutput {
    /** The vehicle number */
    vehicle_number!: string;
    /** The auto-generated id of the vehicle details group master */
    vehicle_details_group_id!: number;
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;

    constructor(data?: IVehicleDetailsGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_number = _data["vehicle_number"];
            this.vehicle_details_group_id = _data["vehicle_details_group_id"];
            this.vehicle_group_id = _data["vehicle_group_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
        }
    }

    static fromJS(data: any): VehicleDetailsGroupOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_number"] = this.vehicle_number;
        data["vehicle_details_group_id"] = this.vehicle_details_group_id;
        data["vehicle_group_id"] = this.vehicle_group_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        return data; 
    }
}

export interface IVehicleDetailsGroupOutput {
    /** The vehicle number */
    vehicle_number: string;
    /** The auto-generated id of the vehicle details group master */
    vehicle_details_group_id: number;
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
}

